/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Back_To_ChatInputs */

const es_feedback_back_to_chat = /** @type {(inputs: Feedback_Back_To_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver al chat`)
};

const en_feedback_back_to_chat = /** @type {(inputs: Feedback_Back_To_ChatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to chat`)
};

/**
* | output |
* | --- |
* | "Back to chat" |
*
* @param {Feedback_Back_To_ChatInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_back_to_chat = /** @type {((inputs?: Feedback_Back_To_ChatInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Back_To_ChatInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_back_to_chat(inputs)
	return en_feedback_back_to_chat(inputs)
});
export { feedback_back_to_chat as "feedback.back_to_chat" }